import {Component, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {ConfirmationService} from "primeng/api";
import {EiImportDto} from "../../../model/dto/entity/ei-import.dto";
import {EiImportRecordDto} from "../../../model/dto/entity/ei-import-record.dto";
import {ActivatedRoute, Router} from "@angular/router";
import {EiImportService} from "../../../service/api/ei-import.service";
import {EiImportRecordService} from "../../../service/api/ei-import-record.service";
import {EiImportRecordStatusInternal} from "../../../enum/ei-import-record-status-internal.enum";
import {ObjectBaseComponent} from "../../../../../core/shared/object/mvs-object-base/object-base.component";
import {WidgetData} from "../../../../../core/shared/widget/widget-data";
import {MvsFormValueListEntryDto} from "../../../../../core/shared/dto/form/dto/mvs-form-value-list-entry.dto";
import {WidgetHelperButton} from "../../../../../core/shared/basic/widget-helper-button";
import {MvsCoreService} from "../../../../../core/shared/service/mvs-core.service";
import {MvsMessageService} from "../../../../../core/shared/service/message/mvs-message.service";
import {ObserverService} from "../../../../../core/shared/object/service/observer.service";
import {MvsObjectNavigationService} from "../../../../../core/shared/navigation/mvs-object-navigation.service";
import {DtoTemplate} from "../../../../../core/shared/dto/dto-template";
import {FilterCriteria} from "../../../../../core/shared/filter/api/filter.criteria";
import {ObjectRequestList} from "../../../../../core/shared/dto/object/request/object-request-list";
import {Sorting} from "../../../../../core/shared/misc/sorting";
import {WidgetFactory} from "../../../../../core/shared/widget/service/widget.factory";
import {ObjectRequestListGroupBy} from "../../../../../core/shared/dto/object/request/object-request-list-group-by";
import {ObjectRequestListAttribute} from "../../../../../core/shared/dto/object/request/object-request-list-attribute";
import {
    DtoListAttributeRequestAggregateEnum
} from "../../../../../core/shared/dto/enum/dto-list-attribute-request-aggregate.enum";
import {
    ObjectRequestEntityProcessingTypeEnum
} from "../../../../../core/shared/dto/object/request/object-request-entity-processing-type.enum";
import {ObjectIdentifierData} from "../../../../../core/shared/basic/object-identifier-data";
import {QlJoinDto} from "../../../../../core/shared/ql/data/dto/ql-join.dto";
import {ObjectIdentifier} from "../../../../../core/shared/basic/object-identifier";


@Component({
    selector: 'ei-import-object-component',
    templateUrl: 'ei-import-object.component.html',
    standalone: false
})
export class EiImportObjectComponent extends ObjectBaseComponent implements OnInit, OnChanges, OnDestroy {

    basicDataWidget: WidgetData;
    eiImportRecordWidget: WidgetData;

    dto: EiImportDto;
    statusEntries: MvsFormValueListEntryDto[];
    selectedStatus: number;
    totalCount: number;

    eiImportRecord: EiImportRecordDto;
    widgetToolbarButtons: WidgetHelperButton[] = [
        {
            label: 'Resume',
            icon: 'fa-solid fa-play',
            display: true,
            action: 'resume',
            tooltip: 'Resume',
            style: {
                'padding': '1px 8px 1px 4px',
                'border-radius': '4px',
                'background-color': 'var(--primary-color) ',
                'transition': 'all 0.3s ',
            },

            iconStyle: {
                'color': 'var(--surface-0)',
                'font-size': '1.1rem',
            },
            labelStyle: {
                'font-weight': '500',
                'font-size': '0.95rem',
                'color': 'var(--surface-0)',
            }
        },
    ];

    constructor(
        protected coreService: MvsCoreService,
        protected messageService: MvsMessageService,
        protected confirmationService: ConfirmationService,
        protected observerService: ObserverService,
        protected navigationService: MvsObjectNavigationService,
        protected router: Router,
        protected route: ActivatedRoute,
        protected eiImportService: EiImportService,
        protected eiImportRecordService: EiImportRecordService
    ) {
        super(coreService, messageService, confirmationService, observerService);
    }

    /**
     * Initialize Component.
     */


    /**
     * On Object Change.
     */
    onObjectChanged() {

        this.setPageTitle(this.dto.importTypeDtoName);
        this.refreshWidgets();
        this.getTemplate();

        this.route.queryParamMap.subscribe(params => {
            const recordStatus = params.get('recordStatus');

            if (recordStatus) {
                const statusKey = Number(recordStatus);
                this.selectedStatus = statusKey;
                this.refreshReportWidget(statusKey);
            } else {
                this.selectedStatus = null;
                this.refreshReportWidget();
            }

            this.initialized = true;

        });
    }

    getTemplate() {
        this.eiImportRecordService.template(new DtoTemplate()).subscribe(res => {
            this.statusEntries = res.getFormField('status').valueList.entries;
            this.getStatusCount();
        });
    }

    refreshWidgets() {
        const filterCriteria = FilterCriteria.create("e.id", FilterCriteria.cOperatorEqual, this.objectIdentifier.objectId);

        const qlJoins: QlJoinDto[] = [
            {
                joinType: "left",
                type: "entity",
                name: "importType",
                as: "it"
            }
        ];

        this.basicDataWidget = WidgetFactory.createWidgetQl(
            "ei.import.list.widget",
            "Ei Import",
            "ei.EiImport",
            "list",
            [filterCriteria],
            [new Sorting("e.createdDate", false)],
            qlJoins
        );

    }

    refreshReportWidget(statusKey?: number) {
        const filterCriteria: FilterCriteria[] = [
            FilterCriteria.create('ei.ei_import_id', FilterCriteria.cOperatorEqual, this.objectIdentifier.objectId),
            FilterCriteria.create('ei.import_type_id', FilterCriteria.cOperatorEqual, this.dto.importTypeDtoId)];

        if (statusKey != null || statusKey != undefined) {
            filterCriteria.push(FilterCriteria.create('ei.status', FilterCriteria.cOperatorEqual, statusKey));
        }


        const objectRequestList = ObjectRequestList.createBasic(
            true,
            filterCriteria,
            []);


        this.eiImportRecordWidget = WidgetFactory.createWidget(
            "ei.import.import.record.report",
            "Import Records",
            "table",
            "list",
            "report",
            "ei.run.12"
        );
        this.eiImportRecordWidget.dataProviderListRequest = objectRequestList;
    }

    resumeImport() {

        if (this.busy) {
            return;
        }

        this.busy = true;
        this.updateResumeIcon();

        this.eiImportService.resumeImport(this.objectIdentifier.objectId).subscribe((res: EiImportDto) => {
            this.refreshObject(true);
            this.busy = false;
            this.updateResumeIcon();
        }, error => {
            this.busy = false;
            this.updateResumeIcon();
        });
    }

    getStatusCount() {

        this.totalCount = 0;

        const objectRequestList = ObjectRequestListGroupBy.create(
            false,
            [FilterCriteria.create('eiImport', FilterCriteria.cOperatorEqual, this.objectIdentifier.objectId)],
            [],
            ['status'],
            [new ObjectRequestListAttribute('status', "Anzahl", DtoListAttributeRequestAggregateEnum.count)],
            ObjectRequestEntityProcessingTypeEnum.regular
        );

        this.eiImportRecordService.groupBy(objectRequestList).subscribe(groupBy => {
            for (let statusEntry of this.statusEntries) {
                statusEntry['uiSelected'] = false;
                const findStatus = groupBy.entries.find(entry => entry['status'] == statusEntry.key);

                if (findStatus) {
                    statusEntry['count'] = findStatus['status_count'];
                    this.totalCount += findStatus['status_count'];
                } else {
                    statusEntry['count'] = 0;
                }
            }
        });
    }

    updateResumeIcon() {
        this.widgetToolbarButtons[0].icon = this.busy ? 'fa-solid fa-circle-notch fa-spin' : 'fa-solid fa-play';
    }

    navigateToRecord(id: number) {
        this.router.navigate(['record', id], {relativeTo: this.route});
    }

    handleObjectSelect(event: ObjectIdentifierData | ObjectIdentifier) {
        this.navigateToRecord(event.objectId);
    }

    handleToolbarButtonClick(event: WidgetHelperButton) {

        if (event.action === 'resume') {
            this.resumeImport();
        }

    }

    onStatusClick(statusKey?: number) {
        this.router.navigate([], {
            queryParams: {recordStatus: statusKey},
            queryParamsHandling: 'merge',
        });
    }


    ngOnChanges(changes: SimpleChanges) {
        if (!this.initialized) {
            return;
        }
    }

    ngOnDestroy() {
        super.ngOnDestroy();
    }

    protected readonly EiImportRecordStatusInternal = EiImportRecordStatusInternal;
}
